module.exports = __webpack_public_path__ + "img/ree.0aa1662b.png";